type ExtractCheckedIdRecord = {
  checkboxId: string;
  isChecked: boolean;
};

export const extractCheckedId = (
  previousValue: string[],
  currentValue: ExtractCheckedIdRecord
): string[] => {
  const { checkboxId, isChecked } = currentValue;
  if (!isChecked) return previousValue;
  previousValue.push(checkboxId);
  return previousValue;
};
